module.exports = __webpack_public_path__ + "img/icon_download_sponsor.aa9661ab.png";